export const QUERY_PARAM_PARENT_APP_ID = 'appId';
export const QUERY_PARAM_LANGUAGE = 'l';
export const QUERY_PARAM_OTOKEN = 'oToken';
export const QUERY_PARAM_ETOKEN = 'eToken';
export const QUERY_PARAM_CTOKEN = 'cToken';
export const QUERY_PARAM_PTOKEN = 'pToken';
export const QUERY_PARAM_USER_TOKEN = 'user_token';
export const QUERY_PARAM_MFA_TOKEN = 'ahp_mfa';
export const QUERY_PARAM_REDIRECT_TO = 'ahp_rdt';
export const QUERY_PARAM_CARD_INDEX = 'ahp_ci';
export const QUERY_PARAM_DESTINATION = 'dest';
// These two are passed via URL from PS
// Encrypted User Token
export const QUERY_PARAM_UT_TOKEN = 'utToken';
// Encrypted User Id Token
export const QUERY_PARAM_USER_ID_TOKEN = 'uidToken';
// Barcode Last 4 - Will bypass MFA
export const QUERY_PARAM_BARCODE = 'barcode';
